export default __webpack_public_path__ + "static/favicon-c43af53755e25a471ff3e75bd909843f.ico";